import axios from "../api/axios";
import useAxiosPrivate from "./useAxiosPrivate";
import { useNavigate } from 'react-router-dom';
import jwt_decode from "jwt-decode";
const useAuth = {
    // Salt code for password
    Salt() {
        // Run one time for gen salt
        // const salt = bcrypt.genSaltSync(10);
        //  =>  $2a$10$1toXdMroaNgF19zXuwIwYu
        const Salt = '$2a$10$1toXdMroaNgF19zXuwIwYu';
        return Salt;
    },

    // Login
    async Login(req) {
        const response = await axios
            .post('/login', req, { withCredentials: true });
        return response;
    },

    // Logout
    async Logout(req) {
        localStorage.removeItem("token");
        const response = await axios
            .post('/logout', '', { withCredentials: true });
        return response;
    },

    // SignUp
    async Signup(req) {
        const response = await axios
            .post('/signup', req);
        return response;
    },

    // Changepassword
    async Changepassword(req) {
        const response = await axios
            .post('/changepassword', req);
        return response;
    },

    // Set token to local storage
    SetToken(token) {
        localStorage.removeItem("token");
        localStorage.setItem("token", token);
    },

    // Get token from local storage
    GetToken() {
        try {
            if (localStorage.getItem("token") == undefined || localStorage.getItem("token") == '') {
                localStorage.removeItem("token");
            } else {
                // set for get value from token when no have value in token get same thing error it will go to catch and remove token
                jwt_decode(localStorage.getItem("token"));

                // return token 
                return localStorage.getItem("token");
            }
        } catch (e) {
            localStorage.removeItem("token");
        }
    },

    // Get USER_ID
    userId() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["user_id"];
    },

    // Get MID
    mid() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["mid"];
    },

    // Get branch_id
    branchId() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["branch_id"];
    },

    // Get Package
    packageName() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["mpk"];
    },

    package(pkcheck) {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        let mpk = token["mpk"];
        if (pkcheck != '') {
            if (pkcheck.includes(mpk)) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    },

    checkRole() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        let role = token["role"];
        if (role == 'admin') {
            return true;
        } else {
            return false;
        }
    },

    checkPermissionNull() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        let rp = token["rp"];
        if (token["role"] != 'admin') {
            if (rp == null || rp == '') {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    },

    checkPermission(link, sublink) {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        let rp = token["rp"];
        if (token["role"] != 'admin') {
            if (rp == null || rp == '') {
                return false;
            } else {
                let permission = JSON.parse(token["rp"]);
                if (permission[link] == undefined || !permission[link]) {
                    return false;
                } else {
                    if (permission[link][sublink] == undefined || !permission[link][sublink]) {
                        return false;
                    } else {
                        if (permission[link][sublink] == 'Y') {
                            return true
                        } else {
                            return false;
                        }
                    }
                }
            }
        } else {
            return true
        }
    },

    // Get Role
    role() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["role"];
    },

    // Get Package expire status
    pakage() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["mpk"];
    },

    // Get Package expire status
    pkRegister() {
        let pk = this.pakage();
        // End of day after package expire 3days
        if (pk == null || pk == '') {
            return false;
        } else {
            return true;
        }
    },

    // Get Package expire status
    pkExpire() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["expire"];
    },

    // Get Package expire status
    pkExpireStatus() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["expire_status"];
    },

    // Get Package expire count days
    pkExpireCountDay() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["count_expire_days"];
    },

    // Get Package expire count days
    pkExpireLastDay() {
        // Check token null
        if (this.GetToken() == null) return false

        let countDays = this.pkExpireCountDay();
        // End of day after package expire 3days
        if (countDays < -2) {
            return true;
        } else {
            return false;
        }
    },

    // Get Package unlimit
    pkUnlimit() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["unlimit"];
    },
    // Get USER_ID
    userName() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["username"];
    },

    // Get Name
    Name() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["first_name"] + ' ' + token["last_name"];
    },

    // Get Name
    userImage() {
        // Check token null
        if (this.GetToken() == null) return false

        const token = jwt_decode(this.GetToken());
        return token["profile_image"];
    },

    async AuthToken() {
        const axiosPrivate = useAxiosPrivate();
        const navigate = useNavigate();
        try {
            const res = await axiosPrivate.get('authtoken');
            return res;

        } catch (error) {

            navigate("/login");
        }
    }
}



export default useAuth;